import fvSubassembly from "../fvSubassembly";
export default class fvEllipseObj extends fvSubassembly{
    constructor(sContent, parent, system, callback) {
        super(sContent, parent, system);
        this.create();
        if (this.isDelayedWaiting) {
            this.complete = callback;
        } else {
            callback(this);
        }
        //创建图元
        //添加折线
        this.ellipseDom = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse')
        system.appendChild(this.ellipseDom);
        if(this.renderType==4||this.renderType==5||this.renderType==6){
            this.ellipseDefs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
            system.insertBefore(this.ellipseDefs, this.ellipseDom);
        }
        this.createSucss(this.ellipseDom, sContent);
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.lineEllipseDom = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                system.appendChild(this.lineEllipseDom);
            }
        }
        //创建样式
        this.parent = parent;
        this.createStyle();

    }
    createStyle() {
        this.setPosition();
        this.ellipseDom.style.width = this.width + "px";
        this.ellipseDom.style.height = this.height + "px";
        this.ellipseDom.style.strokeWidth = this.borderWidth;
        this.setBorderColor();
        //线型
        super.chooseRenderType(this.lineType, this.ellipseDom);
        this.setFillColor();
        //风格，移动等预制动画
        this.Render();
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.lineEllipseDom.innerHTML = "";
                this.drawStereo(this.lineEllipseDom, this.ellipseDom);
            }
        }
		
    }
    // 设置位置
    setPosition() {
        this.ellipseDom.setAttribute('cx', (this.cx - this.parent.parentX + this.width / 2)-this.borderWidth);
        this.ellipseDom.setAttribute('cy', (this.cy - this.parent.parentY + this.height / 2)-this.borderWidth);
        this.ellipseDom.setAttribute('rx', this.width / 2);
        this.ellipseDom.setAttribute('ry', this.height / 2);
    }
    // 设置填充颜色
    setFillColor() {
        this.isHollow();
    }
    // 设置边框颜色
    setBorderColor() {
        this.ellipseDom.style.stroke = this.borderColor;
    }
    // 显示隐藏
    isShow(value) {
        value ? this.ellipseDom.style.display = 'block' : this.ellipseDom.style.display = 'none';
    }
    init() {
        super.init();
        this.moveWidth = this.borderWidth / 2;
    }
    //调用动画 完成动画 更改实时样式
    onDraw() {
        this.executePreAnimation(this.ellipseDom);
        this.ellipseDom.style.transform = `translate(${this.translateX + 'px'}, ${this.translateY + 'px'}) rotate(${this.rotating + 'deg'}`;
        this.ellipseDom.style.transformOrigin = `${this.originPinitX + "px"}  ${this.originPinitY + "px"}`;
    }
    //风格渲染
Render() {
    if (this.renderConfig == undefined || JSON.stringify(this.renderConfig) == "{}") return;
    switch (this.renderType) {
        // case 1:  //模式1
        // case 2:  //模式2
        // case 3:  //模式3
        case 4:  //svg线性渐变效果
            this.linearGradient(this.uuid(),this.renderConfig,this.ellipseDom,this.cx - this.parent.parentX,this.cy - this.parent.parentY,this.ellipseDefs);
            break;
        case 5:  //svg路径渐变效果
            this.radialGradient(this.uuid(),this.renderConfig,this.ellipseDom,this.cx - this.parent.parentX,this.cy - this.parent.parentY,this.ellipseDefs);
            break;
        case 6:  //svg纹理渐变效果
            this.pattern(this.uuid(),this.ellipseDom,this.ellipseDefs);
                break;
        default:
            break;
    }
}
    //是否是空心
    isHollow() {
        if (this.color == "" || this.opacity <= 0) {
            this.ellipseDom.style.fill = 'rgba(0, 0, 0, 0)';
        } else {
            let rgbArray = this.color.colorRgb(this.opacity / 255);
            this.ellipseDom.style.fill = rgbArray
        }
    }
    //生成path路径
    getEllipsePath(cx, cy, rx, ry) {
        //非数值单位计算，如当宽度像100%则移除
        if (isNaN(cx - cy + rx - ry)) return;
        var path = 
            'M' + (cx-rx) + ' ' + cy +
            'a' + rx + ' ' + ry + ' 0 1 0 ' + 2*rx + ' 0' + 
            'a' + rx + ' ' + ry + ' 0 1 0 ' + (-2*rx) + ' 0' + 
            'z'; 

        return path;
    }
}



// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvEllipseObj.js